import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { OnboardSelect } from '../../components/Onboard/OnboardComponents/Dropdown/Select';
import { useDispatch, useSelector } from 'react-redux';
import { getAdditionalReciepientsData, getAquaaIcedL1Category, getAquaaIcedL2Category, updateAquaaIcedDataStart } from '../../actions/Applications/aquaa.action';
import { debounce } from '@material-ui/core';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import MultipleSelectChip from '../Reusable components/MultiselectwithSearch';

const OPTIONS = [
    {
        "option": "Met"
    },
    {
        "option": "Not Met"
    }
  ]
const IcedSubmitForm = () => {
     const location = useLocation();
     const dispatch = useDispatch();
     const history = useHistory();
  const rowData = location.state?.rowData ? location.state?.rowData : [];

    const aquaaIcedL1Category = useSelector((state) => state.aquaaReducer.aquaaIcedL1Category);
    const aquaaIcedL2Category = useSelector((state) => state.aquaaReducer.aquaaIcedL2Category);
    const additionalReciepients = useSelector((state) => state.aquaaReducer.additionalReciepients)
    
  const [validation,setValidation] = useState(false)
  const [formData, setFormData] = useState({
    contactId: '',
    contactDuration: '',
    disconnectReason: '',
    metnotmet: '',
    process:'',
    comment:'',
    l1Category:'',
    l2Category:''
  });

  useEffect(()=>{
      dispatch(getAquaaIcedL1Category());
      dispatch(getAquaaIcedL2Category());
    },[dispatch])

   const [selectedRecipient, setSelectedRecipient] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
  
    // Debounced search function
    const debouncedSearch = debounce((query) => {
      dispatch(getAdditionalReciepientsData(query));  // Make the API call with search query
    }, 500); // 500ms debounce time, adjust as needed
  
   const handleRecipientChange = (newSelection) => {
    const filteredSelection = newSelection.filter(val => val != null);
    setSelectedRecipient(filteredSelection);
  };
    const handleSearchChange = (event) => {
      const query = event.target.value;
      setSearchQuery(query);
     debouncedSearch(query);
    };


    const convertToStringArray = (data) => {
    return data.map((item) => item.email);
  };

console.log('selectedRecipient',selectedRecipient)

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  let Data = [
    {
      "ICED_SID":rowData.Sid,
      "ContactID":formData.contactId,
      "ContactDurationSeconds":formData.contactDuration,
      "DisconnectReason":formData.disconnectReason,
      "L1CategoryID":formData.l1Category,
      "L2CategoryID":formData.l2Category,
      "Assessment":formData.metnotmet,
      "Process":formData.process,
      "Comments":formData.comment,
      "AgentID":rowData.AgentID,
      "AccountID":rowData.AccountID,
      "selectedRecipient":selectedRecipient
    }
  ]

  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
  }

  const dispatchHandler = () =>{
    const temp_Arr = {
            "L1CategoryID":formData.l1Category,
      "L2CategoryID":formData.l2Category,
      "Assessment":formData.metnotmet,
      "Process":formData.process,
      "Comments":formData.comment,
        }
    const isEmptyInput = Object.values(temp_Arr).some(x => (x === null || x === '' || x === undefined));
    if(isEmptyInput){
     setValidation(true)
    }
    else{
      setValidation(false)
    dispatch(updateAquaaIcedDataStart(Data)); 
    history.push('/icedupdate');
    }
  }

  console.log('mmmmmmmmmm',formData);
  console.log('mmmmmmmmmm row',rowData)
  return (
   // <div style={{width:1150,margin:'auto'}}>
     <div> 
      <AdminBreadcrumb value1={()=>history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/aquaaapplications')} label2='AQuAA'
       isActive3={true} label3='AQuAA - ICED' value3={()=>history.push('/icedupdate')} isActive4={false} label4='ICED - Evaluation Form'/>

       <div className='Applications_Title' style={{padding:'20px',paddingLeft:10}}> ICED - Evaluation Form</div>

      <main className='icedSubmitDisplayData' style={{ display: 'flex', gap: '40px', marginTop: 20 }}>
               <div >
                 <label>Agent</label>
                 <div className='static_info'>{rowData.Agent}</div>
               </div>
               <div >
                 <label>Date</label>
                 <div className='static_info'>{formatDate(rowData?.['Start Date'])}</div>
               </div>
               <div >
                 <label>Ticket</label>
                 <div className='static_info'>{rowData.Ticket}</div>
               </div>
             
             </main>
{validation && <main> Please Ensure you filled all the inputs with  " * " mark </main>}
      <main className='aquaaFilterAlignment'>
      {/* Input: Account */}
      <div className='container-two'>
        <label>Contact Id</label><br />
        <input
          type="text"
          value={formData.contactId}
          onChange={(e) => handleChange('contactId', e.target.value)}
        />
      </div>

      {/* Input: Agent */}
      <div className='container-two'>
        <label>Contact Duration (sec)</label><br />
        <input
          type="text"
          value={formData.contactDuration}
          onChange={(e) => handleChange('contactDuration', e.target.value)}
        />
      </div>

      {/* Input: Evaluation Date */}
      <div className='container-two'>
        <label>Disconnect Reason</label><br />
        <input
          type="text"
          value={formData.disconnectReason}
          onChange={(e) => handleChange('disconnectReason', e.target.value)}
        />
      </div>

      <main className='Aquaa_dropdown'>
                  <label HtmlFor='l1Category'>L1 Category *</label>
                  <OnboardSelect data={aquaaIcedL1Category} name='l1Category' value='l1 Category' id='id' marginTop='10px'
                    editValue='' passFullObject={true} addValueToQueue={(name, selectedValue) => {
      setFormData(prev => ({
        ...prev,
        l1Category: selectedValue?.id
      }));
    }} />
                </main>
                <main className='Aquaa_dropdown'>
                  <label HtmlFor='l2Category'>L2 Category *</label>
                  <OnboardSelect data={aquaaIcedL2Category} name='l2Category' value='l2 Category' id='id' marginTop='10px'
                    editValue='' passFullObject={true} addValueToQueue={(name, selectedValue) => {
      setFormData(prev => ({
        ...prev,
        l2Category: selectedValue?.id
      }));
    }} />
                </main>
      </main>
   <div className='aquaaFilterAlignment'>
 <main className='Aquaa_dropdown' style={{width:'100px'}}>
                  <label HtmlFor='metnotmet'>Met / NotMet *</label>
                  <OnboardSelect data={OPTIONS} name='metnotmet' value='option' id='Id' marginTop='10px'
                    editValue='' addValueToQueue={(name, selectedValue) => {
      setFormData(prev => ({
        ...prev,
        metnotmet: selectedValue
      }));
    }} />
                </main>
                <main className='Aquaa_dropdown' style={{width:'100px'}}>
                  <label HtmlFor='process'>Process *</label>
                  <OnboardSelect data={OPTIONS} name='process' value='option' id='Id' marginTop='10px'
                    editValue='' addValueToQueue={(name, selectedValue) => {
      setFormData(prev => ({
        ...prev,
        process: selectedValue
      }));
    }} />
                </main>
              <div style={{ flex: 0.85, marginLeft: '10px', marginRight: '10px' }}>
  <div><label htmlFor="comment">Comment *</label></div>
  <textarea
    id="comment"
    placeholder="comment"
    value={formData.comment}
    onChange={(e) => handleChange('comment', e.target.value)}
    style={{
      width: '100%',
      height: '100px',
      padding: '10px',
      fontSize: '14px',
      resize: 'vertical',
      borderRadius: '5px',
      border: '1px solid #ccc',
      boxSizing: 'border-box'
    }}
  />
</div>
                   <main className='Aquaa_dropdown'>
                <main className='multiSelectLabel'>Additional Recipient</main>
                    <MultipleSelectChip
                      options={convertToStringArray(additionalReciepients)}
                      label="Recipient"
                      value={selectedRecipient}
                      onChange={handleRecipientChange}
                      searchEnabled={true}
                      placeholder="Search Recipient"
                      searchQuery={searchQuery}  // Pass search query as prop
                      onSearchQueryChange={handleSearchChange}  // Pass handler to update search query
                    />
                </main>
                  
   </div>
<div style={{display:'flex',justifyContent:'center'}}>
    <button className='btn_adduser' 
             onClick={() => {dispatchHandler();
             }}
             >SUBMIT</button></div>
    
    </div>
  )
}

export default IcedSubmitForm